module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-lightitalic-webfont.2b80d817.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-lightitalic-webfont.eot
// module id = 95
// module chunks = 3